import { regionsChanged } from "../../actions/filters";
import makeGroupedMultiSelect from "../../../../shared/make_grouped_multi_select";

const valuesSelector = (state) => state.filters.regions.selectedValues;
const optionsSelector = (state) => state.filters.regions.options;

export default makeGroupedMultiSelect(regionsChanged, "Regions", valuesSelector, optionsSelector, { clearable: true, placeholder: "Filter by region / state" }, { "col-md-3": true });
